import React, { ReactElement } from 'react'
import { InjectedIntlProps, injectIntl } from 'react-intl'
import ArrowRight from '@uniiverse/library/assets/arrow-right-thin.svg'

import locale from './locale'

const style = require('./EventSubSection.css')

interface ViewAllButtonProps {
  active: boolean,
  onClick?: () => void,
}

const ViewAllButtonComponent = ({
  active,
  onClick,
  intl: { formatMessage },
}: ViewAllButtonProps & InjectedIntlProps) => (
  <button className={style.viewAllButton} onClick={onClick}>
    <span>{formatMessage(locale.viewAll)}</span>
    <div className={`${style.icon} ${active && style.rotate}`}>
      <ArrowRight />
    </div>
  </button>
)

export const ViewAllButton = injectIntl(ViewAllButtonComponent)

interface Props {
  title: string,
  children: ReactElement,
  viewAllHandler?: () => void,
  isShowingAll?: boolean,
  extendedClassName?: string,
}

export const EventSubSection = ({
  title,
  viewAllHandler,
  extendedClassName,
  children,
  isShowingAll,
}: Props) =>
  (
    <div className={`${style.eventSubSectionWrapper} ${extendedClassName}`}>
      <div className={style.eventSubSectionHeaderContainer}>
        {
          title &&
            <h2 className={style.eventSubSectionTitle}>{title}</h2>
        }
        {
          viewAllHandler &&
            <ViewAllButton active={isShowingAll} onClick={viewAllHandler} />
        }
      </div>
      {children}
    </div>
  )
